/* eslint-disable react/no-unsafe */
import React, { Component } from 'react';

import { ToKolonnerForskelligTekstProps, ToKolonnerForskelligTekstState } from './toKolonnerForskelligTekst.definition';

export class ToKolonnerForskelligTekst extends Component<ToKolonnerForskelligTekstProps, ToKolonnerForskelligTekstState> {
	constructor(props: any) {
		super(props);
		this.state = {
			width: window.innerWidth
		};
	}

	UNSAFE_componentWillMount() {
		window.addEventListener('resize', this.handleWindowSizeChange);
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.handleWindowSizeChange);
	}

	handleWindowSizeChange = () => {
		this.setState({ width: window.innerWidth });
	};

	render() {
		const { width } = this.state;
		let isMobile = width <= 400;

		if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
			isMobile = true;
		}

		const top =
			isMobile ? (
				<div className="toKolonnerForskelligTekst row base-band" style={ { backgroundColor: this.props.backgroundColor } }>
					<section className="columns medium-4 large-4" >
						<h1 dangerouslySetInnerHTML={ { __html: this.props.textLeft } } />
					</section>
					<section className="columns medium-8 large-8" >
						<span dangerouslySetInnerHTML={ { __html: this.props.textRight } } />
					</section>
				</div>
			)
				: (
					<div className="toKolonnerForskelligTekst row base-band" style={ { backgroundColor: this.props.backgroundColor } }>
						<section className="columns medium-4 large-4" >
							<h1 dangerouslySetInnerHTML={ { __html: this.props.textLeft } } />
						</section>
						<section className="columns medium-8 large-8" >
							<span dangerouslySetInnerHTML={ { __html: this.props.textRight } } />
						</section>
					</div>
				);

		return (
			<div>
				{ top }
			</div>
		);
	}
}

export default ToKolonnerForskelligTekst;